const setupFetchInterceptor = (login: (token: string) => void, logout: () => void) => {
    const originalFetch = window.fetch;

    window.fetch = async (url, options = {}) => {
        const token = localStorage.getItem('token');

        const headers = {
            ...options.headers,
            Authorization: `Bearer ${token}`,
        };

        const updatedOptions = { ...options, headers };
        let response = await originalFetch(url, updatedOptions);

        if (response.status === 401) {
            const refreshTokenResponse = await originalFetch('appservice/refresh', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (refreshTokenResponse.ok) {
                const data = await refreshTokenResponse.json();
                if(data) {
                    const newToken = data.token;
                    localStorage.setItem('token', newToken);
    
                    login(newToken);
    
                    headers.Authorization = `Bearer ${newToken}`;
                    response = await originalFetch(url, { ...options, headers });
                }
            } else {
                localStorage.removeItem('token');
                logout();
            }
        }

        return response;
    };
};

export default setupFetchInterceptor;
